"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleSwitch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var Icon_1 = require("../../atoms/Icon/Icon");
var Typography_1 = require("../../atoms/Typography/Typography");
var ToggleSwitch_style_1 = __importDefault(require("./ToggleSwitch.style"));
/**
 * ToggleSwitch molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-toggleswitch--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/ToggleSwitch Source}
 */
var ToggleSwitch = function (_a) {
    var checked = _a.checked, icon = _a.icon, title = _a.title, onChange = _a.onChange, spacious = _a.spacious, className = _a.className, _b = _a.labelPlacement, labelPlacement = _b === void 0 ? 'start' : _b, isDisabled = _a.isDisabled;
    var classes = (0, ToggleSwitch_style_1.default)();
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(className, classes.root) }, { children: (0, jsx_runtime_1.jsx)(core_1.FormControlLabel, { onChange: function (_, checked) { return onChange(checked); }, value: 'start', control: (0, jsx_runtime_1.jsx)(core_1.Switch, { checked: checked, color: 'primary', disableRipple: true, size: 'small', classes: {
                    root: classes.switchRoot,
                    switchBase: classes.switchBase,
                    track: (0, classnames_1.default)(classes.switchTrack, checked && classes.switchTrackChecked),
                }, disabled: isDisabled }), label: renderLabel(), labelPlacement: labelPlacement, classes: {
                root: (0, classnames_1.default)(classes.switch, isDisabled && classes.disabled, spacious && classes.fullWidth),
                label: classes.label,
            } }) })));
    function renderLabel() {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [icon && (0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: classes.icon, iconPath: icon, color: theme_1.default.textColors.primary }), (0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ variant: spacious ? 'body' : 'label1', bold: !spacious, className: (0, classnames_1.default)(spacious && classes.spacious, classes.title) }, { children: title }))] }));
    }
};
exports.ToggleSwitch = ToggleSwitch;
